export * from "-!../../../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./es.vue?vue&type=template&id=27001f36"


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/pages/sitepages/bonus-rules/bonus-rules-coupon/es.vue?vue&type=template&id=27001f36
// module id = jThS
// module chunks = 0